import gql from 'graphql-tag';

export type { GetCountryNameResponse } from '@coursera/grpc-types-countrynames/coursera/proto/countrynames/v1/country_names_api';

const CountryNameQuery = gql`
  query CountryNameQuery($countryNameQueryInput: GetCountryNameRequest!) {
    GetCountryName(input: $countryNameQueryInput)
      @rest(type: "GetCountryName", path: "grpc/countrynames/v1/CountryNamesAPI/GetCountryName", method: "POST") {
      country
    }
  }
`;
export default CountryNameQuery;
